import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Gamepad2, MessageSquare, Calendar, LayoutTemplate, Sliders, Check } from 'lucide-react';
import { Button } from './Button';
export function Modules() {
  const modules = [{
    id: 1,
    title: 'Clases Listas para Usar',
    hangul: '수업',
    hangulMeaning: 'Clase',
    icon: <BookOpen className="w-5 h-5 md:w-6 md:h-6" data-id="element-161" />,
    items: ['10 a 20 clases completas', 'Objetivo, desarrollo y cierre', 'Actividades incluidas', 'Progresión por nivel']
  }, {
    id: 2,
    title: 'Banco de Actividades Dinámicas',
    hangul: '활동',
    hangulMeaning: 'Actividad',
    icon: <Gamepad2 className="w-5 h-5 md:w-6 md:h-6" data-id="element-162" />,
    items: ['+50 actividades listas', 'Juegos y dinámicas', 'Rompe hielo', 'Adaptación por nivel']
  }, {
    id: 3,
    title: 'Guión de Clase Paso a Paso',
    hangul: '대본',
    hangulMeaning: 'Guión',
    icon: <MessageSquare className="w-5 h-5 md:w-6 md:h-6" data-id="element-163" />,
    items: ['Qué decir en cada momento', 'Cómo explicar mejor', 'Cómo hacer participar', 'Cómo cerrar la clase']
  }, {
    id: 4,
    title: 'Planificación (4 semanas)',
    hangul: '계획',
    hangulMeaning: 'Plan',
    icon: <Calendar className="w-5 h-5 md:w-6 md:h-6" data-id="element-164" />,
    items: ['Programa completo de un mes', 'Organización por semanas', 'Clases conectadas entre sí', 'Progresión lógica']
  }, {
    id: 5,
    title: 'Plantillas Editables PRO',
    hangul: '서식',
    hangulMeaning: 'Plantilla',
    icon: <LayoutTemplate className="w-5 h-5 md:w-6 md:h-6" data-id="element-165" />,
    items: ['Planificación semanal', 'Estructura de clase', 'Sistema organizativo', 'Listo para replicar']
  }, {
    id: 6,
    title: 'Adaptación por Nivel',
    hangul: '단계',
    hangulMeaning: 'Nivel',
    icon: <Sliders className="w-5 h-5 md:w-6 md:h-6" data-id="element-166" />,
    items: ['Principiante e intermedio', 'Cómo ajustar sin rehacer', 'Cómo evitar abandono', 'Cómo mejorar resultados']
  }];
  return <section className="py-12 md:py-24 bg-white relative overflow-hidden" data-id="element-167">
      {/* Subtle hangul pattern background */}
      <div className="absolute top-1/4 -left-10 text-brand-50 text-[200px] md:text-[300px] font-extrabold select-none pointer-events-none leading-none" data-id="element-168">
        한
      </div>
      <div className="absolute bottom-1/4 -right-10 text-brand-50 text-[200px] md:text-[300px] font-extrabold select-none pointer-events-none leading-none" data-id="element-169">
        글
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-170">
        <div className="text-center max-w-3xl mx-auto mb-8 md:mb-16" data-id="element-171">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-100 text-brand-700 font-bold mb-3 md:mb-4 text-xs md:text-sm" data-id="element-172">
            <span className="font-extrabold" data-id="element-173">📚 시스템</span>
            <span data-id="element-174">· El Sistema Completo</span>
          </div>
          <h2 className="text-2xl md:text-5xl font-extrabold text-brand-950 mb-3 md:mb-6" data-id="element-175">
            ¿Qué incluye Profe Coreano Pro?
          </h2>
          <p className="text-base md:text-xl text-brand-600 font-medium" data-id="element-176">
            Sistema completo de recursos listos para usar desde el primer día.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8 max-w-6xl mx-auto mb-8 md:mb-16" data-id="element-177">
          {modules.map((mod, index) => <motion.div key={mod.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-30px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.08
        }} className="bg-white rounded-2xl md:rounded-3xl p-4 md:p-8 shadow-soft border border-brand-100 hover:border-brand-300 hover:shadow-lg transition-all group relative overflow-hidden" data-id="element-178">
              {/* Big hangul watermark in corner */}
              <div className="absolute -top-2 -right-2 text-brand-50 text-6xl md:text-8xl font-extrabold select-none pointer-events-none leading-none group-hover:text-accent-50 transition-colors" data-id="element-179">
                {mod.hangul}
              </div>

              <div className="flex items-center gap-3 md:gap-4 mb-3 md:mb-6 relative z-10" data-id="element-180">
                <div className="w-10 h-10 md:w-14 md:h-14 rounded-xl md:rounded-2xl bg-brand-50 text-brand-600 flex items-center justify-center shrink-0 group-hover:bg-brand-600 group-hover:text-white transition-colors" data-id="element-181">
                  {mod.icon}
                </div>
                <div className="min-w-0" data-id="element-182">
                  <div className="flex items-center gap-1.5 mb-0.5 md:mb-1" data-id="element-183">
                    <div className="text-[10px] md:text-sm font-bold text-accent-500 uppercase tracking-wider" data-id="element-184">
                      Módulo {mod.id}
                    </div>
                    <span className="text-[9px] md:text-[11px] font-medium text-brand-400 bg-brand-50 px-1.5 py-0.5 rounded" data-id="element-185">
                      {mod.hangul}
                    </span>
                  </div>
                  <h3 className="text-base md:text-xl font-bold text-brand-950 leading-tight" data-id="element-186">
                    {mod.title}
                  </h3>
                </div>
              </div>

              <ul className="space-y-1.5 md:space-y-3 relative z-10" data-id="element-187">
                {mod.items.map((item, i) => <li key={i} className="flex items-start gap-2 md:gap-3" data-id="element-188">
                    <div className="mt-1 bg-green-100 p-0.5 rounded-full shrink-0" data-id="element-189">
                      <Check className="w-3 h-3 md:w-3.5 md:h-3.5 text-green-600" data-id="element-190" />
                    </div>
                    <span className="text-sm md:text-base text-brand-700 font-medium leading-snug" data-id="element-191">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-192">
          <Button href="#comprar" size="lg" className="w-full sm:w-auto md:!px-10 md:!py-5 md:!text-xl" data-id="element-193">
            Acceder al Sistema PRO ahora
          </Button>
          <p className="mt-3 md:mt-4 text-sm text-brand-500 font-medium" data-id="element-194">
            <span className="text-accent-500 font-bold" data-id="element-195">화이팅!</span> Es tu
            momento de enseñar como un profesional.
          </p>
        </div>
      </div>
    </section>;
}